var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose2X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24/Close") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/24/Close",
    stroke: "#000000",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 14,
    y2: 14,
    id: "Path-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 14,
    y2: 14,
    id: "Path-9",
    transform: "translate(7.000000, 7.000000) scale(-1, 1) translate(-7.000000, -7.000000) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose2X);
export default __webpack_public_path__ + "static/media/close2x.ac75f32f83ff5da89884528c998a4af7.svg";
export { ForwardRef as ReactComponent };